// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1_lgl","cls2":"SuggestionCard-cls2__2t SuggestionCard-cls1_lgl","small":"SuggestionCard-small__79"};